import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike, Order } from "../../../../../db/models/decontamination/order";
import { OrderItemLike } from "../../../../../db/models/decontamination/orderItem";
import { OrderDetailViewData } from "../../detail/index";
import AddOrderItemModalView from "../../modals/add-item";

export default class OrderItemsTabView extends View
{
    public template = Template.lazy('/app/views/decontamination/order/tab/items/index.html');
    public app: FortumApp;
    public data: OrderItemsTabViewData;
    public container: HTMLElement;

    constructor(data?: OrderItemsTabViewData) 
    {
        super(data);
    }

    private onAddOrderItemButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.openModal(AddOrderItemModalView, sender, this.data, {
            tab: 'items'
        });
    }
}

export interface OrderItemsTabViewData extends OrderDetailViewData
{

}